<section class="mobile-nav p-3">
    <header class="text-center pt-5">
        <a class="mobile-nav__close-button"><img src="https://d3uee0gs4p7cty.cloudfront.net/icons/close-icon.svg"
                alt="close icon" (click)="closeMenu()"></a>
        <a href="https://fitscovery.com" target="_blank">
            <img alt="fitscovery logo" class="nav-logo"
                src="https://d3uee0gs4p7cty.cloudfront.net/default-images/logo/logo_b.png">
        </a>
        <h3 class="pt-4 px-2 ellipsis" *ngIf="(userAuthState$ | async) as user">Hi, {{user.displayName}}!</h3>
    </header>
    <article class="mobile-nav__cont row d-flex align-items-center text-center py-2">
        <div class="mobile-nav__options col-md-5 col-11 text-center d-flex flex-column justify-content-between p-0">
            <ul class="p-0">
                <li class="option__be-a-member">
                  <fitscovery-membership-button
                    (click)="closeMenu()">
                  </fitscovery-membership-button>
                </li>
                <li routerLink="/community" (click)="closeMenu()">{{ 'toolbars.communityMenuOption' | translate }}</li>
                <li routerLink="/events" (click)="closeMenu()">{{ 'toolbars.liveEventsMenuOption' | translate }}</li>
                <li routerLink="/workouts" (click)="closeMenu()">{{ 'toolbars.onDemandMenuOption' | translate }}</li>
                <li routerLink="/booking" (click)="closeMenu()">{{ 'toolbars.bookASessionMenuOption' | translate }}</li>
                <!-- <li>Products</li>
                <li>Resource Hub</li>
                <li>Cart</li> -->
                <hr>
                <li><a [href]="accountUrl" target="_blank">{{ 'toolbars.userAccountMenuOption' | translate }}</a></li>
                <li><a [href]="myDiscoveryUrl" target="_blank">{{ 'toolbars.fitnessTrackerMenuOption' | translate }}</a>
                </li>
            </ul>
            <div>
                <ng-container *ngIf="(userAuthState$ | async); else showLoginButton">
                    <button class="btn btn-primary-outline w-100 py-3 mb-5"
                        (click)="logout()">{{ 'toolbars.logoutMenuOption' | translate }}</button>
                </ng-container>
                <ng-template #showLoginButton>
                    <button class="btn btn-primary-outline login-button w-100 py-3 mb-5"
                        (click)="login()">{{ 'toolbars.loginButtonText' | translate }}</button>
                </ng-template>
            </div>
        </div>
    </article>
</section>